<template>
  <div>
    <div v-if="canEdit" class="flex-align__between table-btn-group">
      <div>
        <div class="upload-button info-button" @click="handleImport">
          <div class="flex-align">
            <img src="@/assets/images/import.png" alt="" />
            批量导入
          </div>

          <input
            v-show="false"
            ref="fileupload"
            type="file"
            name="fileupload"
            :value="uploadFile"
            @change.stop="fileChange"
          />
        </div>

        <download-file
          class="m-l-20"
          download-link="/resources/竞价品目导入模板.xlsx"
        >
          <div class="flex-center">
            <img src="@/assets/images/download.png" alt="" />
            <span>下载品目导入模板</span>
          </div>
        </download-file>
      </div>

      <el-button type="text" class="info-button">
        <div class="flex-align" @click="handleBatchDelete">
          <img src="@/assets/images/delete.png" alt="" />
          批量删除
        </div>
      </el-button>
    </div>
    <el-table
      ref="materialTable"
      border
      highlight-current-row
      header-cell-class-name="table-header"
      :data="pageMaterialList"
      max-height="460"
      @selection-change="handleMaterialTableSelectionChange"
    >
      <el-table-column v-if="canEdit" type="selection" width="60" />
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
      />
      <el-table-column
        label="品目编码"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielCode || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="品目名称"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielName || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="数量"
        align="right"
        header-align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{
            row.materielNum ? strToThousands(row.materielNum) : ' - '
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="参数型号"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielModel || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="!isSupplier"
        label="预算单价（元）"
        align="right"
        header-align="center"
        min-width="110"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{
            row.budgetUnitPrice ? strToThousands(row.budgetUnitPrice) : ' - '
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="!isSupplier"
        label="总价（元）"
        align="right"
        header-align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{
            row.totalPrice ? strToThousands(row.totalPrice) : ' - '
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="品目单位"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.unitType || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.remarks || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="附件" align="center" min-width="160">
        <template slot-scope="{ row }">
          <upload
            v-if="row.attachmentGroupId"
            :props-data="{
              groupIdBefore: row.attachmentGroupId,
              disabled: true
            }"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160" fixed="right">
        <template slot-scope="{ row, $index }">
          <el-button
            v-if="canEdit"
            class="primary-button"
            type="text"
            @click="addOrEditMaterialInfo('edit', row)"
          >编辑</el-button>
          <el-button
            v-if="canEdit"
            class="danger-button"
            type="text"
            @click="handleMaterialRemove(row, $index)"
          >删除</el-button>
          <el-button
            type="text"
            @click="handleMaterialLook(row)"
          >查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--      点击添加品目-->
    <div
      v-if="canEdit"
      class="table-btn flex-center"
      @click="addOrEditMaterialInfo('add')"
    >
      <i class="el-icon-plus"></i> 添加品目
    </div>

    <!--    <pagination-->
    <!--      v-show="materialList.length > 10"-->
    <!--      :total="materialList.length"-->
    <!--      size="small"-->
    <!--      :page.sync="page"-->
    <!--      :limit.sync="size"-->
    <!--      @pagination="getPageData"-->
    <!--    />-->

    <!--    显示上传品目总价-->
    <div v-if="!isSupplier" class="all-count flex col-stretch">
      <div class="all-count__label">全部品目总价汇总：</div>
      <div class="all-count__content">
        {{ strToThousands(totalFee) }} 元
        <money-in-cn :money="totalFee" />
      </div>
    </div>

    <!--    添加或修改品目信息的弹窗-->
    <add-or-edit-material-info-dialog
      v-if="showEditDialog"
      v-model="showEditDialog"
      :title="editDialogTitle"
      :material-info="materialInfo"
      :upload-params="defaultUploadParams"
      @change="handleEditDialogShowChange"
      @material="handleMaterial"
    />

    <!--    查看品目信息的弹窗-->
    <material-detail-dialog
      v-if="showDetailDialog"
      v-model="showDetailDialog"
      :is-supplier="isSupplier"
      :material-info="materialInfo"
      :upload-params="defaultUploadParams"
      title="品目信息详情"
    />
  </div>
</template>

<script>
// 组件
import AddOrEditMaterialInfoDialog from './AddOrEditMaterialInfoDialog'
import MaterialDetailDialog from './MaterialDetailDialog'
import Upload from '@/components/common/Upload/index'
import DownloadFile from '@/components/common/DownloadFile'
import MoneyInCn from '@/components/common/MoneyInCn'
// import Pagination from '@/components/common/Pagination'
// 接口
import { importCompeteMaterialApi } from '@/api/procure/compete'
// 工具方法
import { strToThousands } from '@/utils/utils'
// import { uniq } from 'lodash'

export default {
  name: 'MaterialTable',

  components: {
    AddOrEditMaterialInfoDialog,
    MaterialDetailDialog,
    Upload,
    DownloadFile,
    MoneyInCn
    // Pagination
  },

  props: {
    // 回显的表格数据
    tableData: {
      type: Array,
      default: () => []
    },

    // 是否是可编辑的
    canEdit: {
      type: Boolean,
      default: true
    },

    // 上传组件需要的定义参数
    uploadParams: {
      type: Object,
      default: () => {
        return {
          bidType: '',
          attachmentType: ''
        }
      }
    },

    // 是否是供应商，供应商查看时隐藏单价与总价
    isSupplier: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 品目信息弹窗变量
      showEditDialog: false,
      editDialogTitle: '添加品目信息',
      showDetailDialog: false,

      pageMaterialList: [], // 分页显示的列表
      materialList: [], // 品目列表
      materialInfo: {}, // 暂存的需要操作的品目信息
      materialIndex: -1, // 暂存的需要操作的品目信息在品目表中的下标
      selectedMaterials: [], // 已选择的品目信息

      uploadFile: '', // 上传的文件
      totalFee: 0, // 全部品目总价
      page: 1,
      size: 20
    }
  },

  computed: {
    defaultUploadParams() {
      return this.uploadParams
    },

    totalPage() {
      return this.materialList.length / this.size
    }
  },

  watch: {
    materialList: {
      deep: true,
      handler: function() {
        this.getTotalFee()
      }
    },

    tableData(newVal) {
      if (newVal.length !== 0) {
        this.materialList = [...this.tableData]
        this.getPageData()
      }
    }
  },

  created() {
    if (this.tableData.length !== 0) {
      this.materialList = [...this.tableData]
      this.getPageData()
    }

    this.$nextTick(() => {
      this.listenTable()
    })
  },

  beforeDestroy() {
    const dom = this.$refs.materialTable.bodyWrapper
    dom.removeEventListener('scroll', this.changeScrollDistance)
  },

  methods: {
    strToThousands,

    /**
     * 添加或者编辑品目信息的函数
     * @param {string} type 表示添加还是修改
     * @param {Object} row 当type===edit时使用，需要修改的品目信息
     */
    addOrEditMaterialInfo(type, row) {
      if (type === 'add') {
        this.editDialogTitle = '添加品目信息'
      } else {
        this.editDialogTitle = '修改品目信息'
      }

      if (row) {
        this.materialInfo = row
        this.materialIndex = this.materialList.indexOf(row)
      } else {
        this.materialIndex = -1
      }

      this.showEditDialog = true
    },

    // 弹窗关闭回调
    handleEditDialogShowChange(showDialog) {
      if (!showDialog) this.materialInfo = {}
      this.getPageData()
    },

    // 品目弹窗点击确定回调事件
    handleMaterial(data) {
      // 如果暂存的需要操作的品目信息下标有值，则表示是更新操作，根据下标更新对象值
      if (this.materialIndex >= 0) {
        const tempObj = this.materialList[this.materialIndex]
        this.materialList[this.materialIndex] = Object.assign(tempObj, data)
      } else {
        // 其余为添加操作
        if (this.materialList.length > 200) {
          this.$message.warning('品目条数上限为200条')
          return false
        }
        this.materialList.push(data)
      }
    },

    // 删除品目
    handleMaterialRemove(row, index) {
      this.$systemConfirm('DELETE_MATERIAL').then(result => {
        if (!result) return

        this.materialList.splice(index, 1)
        // this.getTotalFee()
        this.getPageData()
        this.$message.success('删除成功')
      })
    },

    // 查看品目详情
    handleMaterialLook(row) {
      if (row) this.materialInfo = row
      this.showDetailDialog = true
    },

    // 品目表勾选项改变时触发
    handleMaterialTableSelectionChange(selection) {
      this.selectedMaterials = selection
    },

    // 批量删除
    handleBatchDelete() {
      if (this.selectedMaterials.length === 0) {
        this.$message.warning('请先选择需要删除的品目')
        return false
      }

      this.batchRemove()
    },

    // 执行删除操作
    batchRemove() {
      this.$systemConfirm('DELETE_SELECTED_MATERIAL').then(result => {
        if (!result) return

        // 获取已选项在品目列表中的下标
        const tempIndexArray = this.selectedMaterials.map(s => {
          return this.materialList.findIndex(m => m === s)
        })

        // 根据已选项的下标排除数据，返回未选的品目数据
        const tempArray = this.materialList.filter((v, index) => {
          return !tempIndexArray.includes(index)
        })
        // 将未选的品目数据覆盖写入原本的品目表，达到批量删除的目的
        this.materialList = [...tempArray]
        // this.getTotalFee()
        this.getPageData()
        this.$message.success('删除成功')
      })
    },

    // 批量导入
    handleImport() {
      this.$refs.fileupload.click()
    },

    fileChange(e) {
      const fileList = Array.from(e.currentTarget.files)

      if (!fileList[0]) {
        return false
      }

      this.$refs.fileupload.value = ''

      importCompeteMaterialApi({ file: fileList[0] })
        .then(res => {
          const tempArray = this.materialList.concat(res.data || [])
          if (tempArray.length > 200) {
            this.$message.warning('品目条数上限为200条')
            return false
          }
          this.materialList = tempArray
          this.getPageData()
        })
        .catch(err => {
          this.$message.error(err.message || '导入失败')
        })
    },

    // 执行本地的总金额计算
    getTotalFee() {
      let fee = 0

      if (this.materialList.length === 0) {
        this.totalFee = fee
        if (this.canEdit) {
          // this.getGuaranteeFee()
          this.$emit('getTotalFee', this.totalFee)
        }
        return false
      }

      this.materialList.forEach(val => {
        fee = fee + Number(val.totalPrice) * 100
      })

      this.totalFee = fee / 100
      // if (this.canEdit) this.getGuaranteeFee()
      if (this.canEdit) {
        this.$emit('getTotalFee', this.totalFee)
      }
    },

    // 获取保证金
    // getGuaranteeFee() {
    //   guaranteeFeeCalculateApi({ budgetPrice: this.totalFee })
    //     .then(res => {
    //       this.$emit('getGuaranteeFee', Number(res.data.fee))
    //     })
    //     .catch(err => {
    //       this.$message.error(err.message || '获取保证金错误')
    //     })
    // },

    /**
     * @description: 前端分页，获取当前页数据
     */
    getPageData() {
      this.page = Math.ceil(this.materialList.length / this.size)
      const start = (this.page - 1) * this.size
      const end = start + this.size
      this.pageMaterialList = this.materialList.slice(0, end)
      if (this.pageMaterialList.length === 0 && this.page > 1) {
        this.page = this.page - 1
        this.getPageData()
      }
    },

    listenTable() {
      const dom = this.$refs.materialTable.bodyWrapper
      dom.addEventListener('scroll', this.changeScrollDistance)
    },

    changeScrollDistance() {
      const dom = this.$refs.materialTable.bodyWrapper
      const scrollDistance = dom.scrollHeight - dom.scrollTop - dom.clientHeight
      if (scrollDistance <= 0) {
        // 等于0证明已经到底，可以请求接口
        if (this.page < this.totalPage) {
          // 当前页数小于总页数就请求
          this.page++ // 当前页数自增
          // 请求接口的代码
          this.getPageData()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.table-btn-group {
  padding: 0 pixel-to-rem($n: 30);

  ::v-deep .el-button + .el-button {
    margin-left: pixel-to-rem($n: 30);
  }

  img {
    width: pixel-to-rem($n: 26);
    height: pixel-to-rem($n: 26);
    margin-right: pixel-to-rem($n: 10);
    border: none;
  }
}
.table-btn {
  height: pixel-to-rem($n: 60);
  background-color: $primary-background-color;
  color: $primary-color;
  @include text-bold;
  font-size: pixel-to-rem($n: 18);
  cursor: pointer;

  i {
    @include text-bold;
    font-size: pixel-to-rem($n: 18);
    margin-right: pixel-to-rem($n: 10);
    padding-top: 1px;
  }
}

.upload-button {
  display: inline-block;
  margin-right: pixel-to-rem($n: 20);
  cursor: pointer;
  &:hover {
    color: $primary-color;
  }
}

.all-count {
  margin-top: pixel-to-rem($n: 20);
  margin-left: pixel-to-rem($n: 20);
  line-height: 1.5;

  .all-count__label {
    color: $text-color;
    &::before {
      display: inline-block;
      content: '*';
      color: $danger-color;
      margin-right: pixel-to-rem($n: 10);
    }
  }

  .all-count__content {
    //color: $primary-color;
    color: $text-color;
  }
}
</style>
